import { FC, RefObject, useMemo, useRef } from 'react'

import TwitterComment from '../../../UI/Icons/TwitterComment'
import TwitterConfirmedAccount from '../../../UI/Icons/TwitterConfirmedAccount'
import TwitterLike from '../../../UI/Icons/TwitterLike'
import TwitterReply from '../../../UI/Icons/TwitterReply'
import TwitterUpload from '../../../UI/Icons/TwitterUplaod'
import UploadImage from '../../../UploadPostImages'
import MessageField from '../UI/MessageField'
import UploadVideo from '../../../UploadVideo'

import {
  TPostSocialManagePost,
  VIEW_TYPE,
  TFieldChangePayload,
  TRemoveAttachmentPayload,
  TChangeAttachmentExtrafieldPayload
} from '../../../../store/managePost/newTypes'
import { TMediaCallbacks } from '../../../../pages/CreatePost'

import './TwitterEditor.scss'
import { SOCIAL_NETWORK } from '../../../../models/post'
import { TSocialDetails } from '../../../../selectors/ProjectSelector'
import { getTwitterMentionsThunk, hashtagSearchThunk } from '../../../../store/managePost/thunks'
import { useDispatch } from '../../../../store'
import { setPostSocialExtrafieldsAction } from '../../../../store/managePost/slice'

interface TwitterPreviewProps {
  post: TPostSocialManagePost
  onTextChange: (data: TFieldChangePayload) => void
  refMediaCallbaks: RefObject<TMediaCallbacks>
  addMediaToTemporaryLibrary: (data: any) => void
  deleteMediaFromPostSocial: (data: TRemoveAttachmentPayload) => void
  view: VIEW_TYPE
  restrictions: any
  socialDetails: TSocialDetails
  setExtraField: (data: TChangeAttachmentExtrafieldPayload) => void
  publishDate: string
}

const TwitterEditor: FC<TwitterPreviewProps> = ({
  post,
  onTextChange,
  refMediaCallbaks,
  addMediaToTemporaryLibrary,
  restrictions,
  socialDetails,
  publishDate,
  setExtraField,
  deleteMediaFromPostSocial
}) => {
  const formRef = useRef<any>(null)
  const dispatch = useDispatch()

  const socialData = useMemo(() => socialDetails[SOCIAL_NETWORK.TWITTER_SOCIAL], [])
  const getMentions = async (query: string) => {
    return await dispatch(getTwitterMentionsThunk(query))
  }

  const getHashtags = async (query: string)=> 
  await dispatch(hashtagSearchThunk({social: SOCIAL_NETWORK.TWITTER_SOCIAL,query}))


  const setMentionToStore = (mention: any) => {
    dispatch(setPostSocialExtrafieldsAction({ social: SOCIAL_NETWORK.TWITTER_SOCIAL, mention }))
  }

  const manageMediaProps = {
    attachments: post.attachments,
    isEditable: post.isEditable,
    addMediaToPost: addMediaToTemporaryLibrary,
    refMediaCallbaks,
    removeMediaFromStore: deleteMediaFromPostSocial,
    restrictions,
    social: SOCIAL_NETWORK.TWITTER_SOCIAL
  }

  return (
    <div className='twitter-editor post-editor'>
      <div className='twitter-editor__header'>
        <div className='twitter-editor__header__avatar'>
          {socialData.logo.original ? (
            <img
              src={socialData.logo.original}
              alt='any'
              className='twitter-editor__header__avatar__img'
            />
          ) : (
            socialData.logo.default
          )}
        </div>
        <div className='twitter-editor__header__post-meta twitter-post-data'>
          <div className='twitter-post-data__customer-data'>
            <div className='twitter-post-data__customer-data__name'>{socialData.name}</div>
            <div className='twitter-post-data__customer-data__icon'>
              <TwitterConfirmedAccount />
            </div>

            <div className='twitter-post-data__customer-data__login-and-date'>
              {publishDate}
            </div>
            <div className='twitter-post-data__customer-data__arrow-down' />
          </div>
          <div className='twitter-post-data__post-title'>Title</div>
        </div>
      </div>
      <div className='twitter-editor__body twitter-left-margin'>
        {(restrictions.mediaRestrictions.image || restrictions.mediaRestrictions.video) && (
          <div className='twitter-editor__body__attachments'>
            {restrictions.mediaRestrictions.image ? (
              <UploadImage {...manageMediaProps} />
            ) : (
              <UploadVideo {...manageMediaProps} />
            )}
          </div>
        )}
        <div className='twitter-editor__body__message'>
          <MessageField
            {...{
              className: 'twitter-content',
              value: post.message,
              setExtraField,
              extraFields: post.extra_fields,
              setMention: setMentionToStore,
              getHashes: getHashtags,
              editorRaws: post.message_editor_state || null,
              postType: post.type,
              isEditable: post.isEditable,
              onChange: onTextChange,
              social: post.social_network,
              isExist: restrictions.message,
              getMentions,
              maxLength: 280
            }}
          />
        </div>
      </div>
      <div className='twitter-editor__reaction twitter-left-margin'>
        <div className='twitter-editor__reaction__item'>
          <TwitterComment />
        </div>
        <div className='twitter-editor__reaction__item'>
          <TwitterReply />
        </div>
        <div className='twitter-editor__reaction__item'>
          <TwitterLike />
        </div>
        <div className='twitter-editor__reaction__item'>
          <TwitterUpload />
        </div>
      </div>
    </div>
  )
}

export default TwitterEditor
